"use strict";

exports.__esModule = true;
exports.MetricValueElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Metrics = require("../../../Catalogs/Metrics");
var _Core = require("../../Core");
var _Device = require("../../Device");
var _DeviceContext = require("../../Device/DeviceContext");
var _MeasurementValue = require("../../Measures/MeasurementValue");
var _Time = require("../../Time");
var _TimeContext = require("../../Time/TimeContext");
var _common = require("../common");
var _getTarget = require("./getTarget");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _MetricValueBatchContext = require("./MetricValueBatchContext");
var _TileContext = require("../common/TileContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// Gap between a value and its target when they sit side by side in a card.
var FLAT_TARGET_GAP = 14;

/**
 * Displays a particular metric value for a device.
 */
var MetricValueElement = exports.MetricValueElement = function MetricValueElement(props) {
  var height = props.height,
    metricName = props.metricName,
    hideLabel = props.hideLabel,
    showTarget = props.showTarget,
    color = props.color,
    backgroundColor = props.backgroundColor,
    backgroundColorSource = props.backgroundColorSource,
    dataRange = props.dataRange;
  var device = (0, _react.useContext)(_DeviceContext.DeviceContext);
  var tile = (0, _react.useContext)(_TileContext.TileContext) || {};
  var dataAccessor = (0, _react.useContext)(_DataAccessorContext.DataAccessorContext);
  var batch = (0, _react.useContext)(_MetricValueBatchContext.MetricValueBatchContext);
  var _useContext = (0, _react.useContext)(_TimeContext.TimeContext),
    currentWorkday = _useContext.currentWorkday,
    currentShift = _useContext.currentShift;
  var timePeriod = (0, _Time.useSelectionContext)({
    dataRange: dataRange
  });
  var reportingPeriod = timePeriod && timePeriod.name === "shift" ? "shift" : "workday";
  var isCurrent = (0, _Metrics.canSubscribeToRealtime)(currentWorkday.interval, currentShift.interval, timePeriod.interval);
  var _useState = (0, _react.useState)(0),
    metricValue = _useState[0],
    setMetricValue = _useState[1];
  var _useState2 = (0, _react.useState)(0),
    targetValue = _useState2[0],
    setTargetValue = _useState2[1];
  var updateMetricValue = (0, _react.useCallback)(function (value) {
    return setMetricValue(value);
  });
  (0, _react.useEffect)(function () {
    getTargetValueIfTargetEnabled({
      deviceUuid: device.uuid,
      periodType: timePeriod.name,
      currentShift: currentShift.payload.name,
      workDay: currentWorkday.id
    });
  }, []);
  (0, _react.useEffect)(function () {
    getTargetValueIfTargetEnabled({
      deviceUuid: device.uuid,
      periodType: timePeriod.name,
      currentShift: currentShift.payload.name,
      workDay: currentWorkday.id
    });
  }, [currentWorkday, currentShift, reportingPeriod, showTarget, metricName]);
  var metricDefinition = (0, _Metrics.getMetricDefinition)(metricName);
  var getTargetValueIfTargetEnabled = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
      var deviceUuid, periodType, currentShift, workDay, target;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            deviceUuid = _ref.deviceUuid, periodType = _ref.periodType, currentShift = _ref.currentShift, workDay = _ref.workDay;
            if (!showTarget) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return (0, _getTarget.getTarget)({
              deviceUuid: deviceUuid,
              metricName: metricName,
              periodType: periodType,
              workDay: workDay,
              dataAccessor: dataAccessor,
              currentShift: currentShift
            });
          case 1:
            target = _context.v;
            setTargetValue(target);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getTargetValueIfTargetEnabled(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getMetricValue = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3) {
      var deviceUuid, startMillis, endMillis, metricName, queryBuilder, result;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            deviceUuid = _ref3.deviceUuid, startMillis = _ref3.startMillis, endMillis = _ref3.endMillis, metricName = _ref3.metricName;
            queryBuilder = (0, _Metrics.buildMetricQuery)([metricName]);
            queryBuilder.filterByDevice([deviceUuid]);
            queryBuilder.filterByRange(new Date(startMillis).toISOString(), new Date(endMillis).toISOString());
            queryBuilder.aggregateBy(["device"]);
            _context2.n = 1;
            return dataAccessor.getMetrics(queryBuilder.getQuery());
          case 1:
            result = _context2.v;
            if (!(result && result.by_device && result.by_device.length > 0 && result.by_device[0].value)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2, result.by_device[0].value);
          case 2:
            return _context2.a(2, null);
        }
      }, _callee2);
    }));
    return function getMetricValue(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var renderHistoricMetric = function renderHistoricMetric(_ref5) {
    var color = _ref5.color,
      backgroundColor = _ref5.backgroundColor;
    return /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
      load: getMetricValue,
      params: {
        deviceUuid: device.uuid,
        startMillis: timePeriod.interval.startMillis,
        endMillis: timePeriod.interval.endMillis,
        metricName: metricName
      }
    }, function (loaderProps) {
      return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, loaderProps, function (results) {
        return renderMeasurementValueWithOptionalTarget({
          value: results,
          color: color,
          backgroundColor: backgroundColor
        });
      });
    });
  };
  var renderRealtimeMetric = function renderRealtimeMetric(_ref6) {
    var color = _ref6.color,
      backgroundColor = _ref6.backgroundColor;
    return /*#__PURE__*/_react["default"].createElement(_Device.DeviceMetricSubscription, {
      deviceUuid: device.uuid,
      metricName: metricName,
      reportingPeriod: reportingPeriod
    }, function (packet) {
      return renderMeasurementValueWithOptionalTarget({
        value: packet ? packet.value : null,
        color: color,
        backgroundColor: backgroundColor
      });
    });
  };
  var renderMeasurementValueWithOptionalTarget = function renderMeasurementValueWithOptionalTarget(_ref7) {
    var value = _ref7.value,
      color = _ref7.color,
      backgroundColor = _ref7.backgroundColor;
    if (value !== metricValue) {
      setTimeout(function () {
        return updateMetricValue(value);
      }, 0);
    }

    // As a tile the target takes the lower half. Inside a device card the value
    // and its target sit side by side as two stats, each with the full height.
    var _getWidgetPositionPro = (0, _common.getWidgetPositionProps)(props),
      width = _getWidgetPositionPro.width;
    var flat = Boolean(tile.flat);
    var tileWidth = flat && showTarget ? Math.max(0, (width - FLAT_TARGET_GAP) / 2) : width;
    var tileHeight = !flat && showTarget ? height / 2 : height;
    var tiles = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MeasurementValue.MeasurementValue, _extends({
      dataTestId: "MetricValueElement.MetricValue",
      value: value,
      units: metricDefinition.units,
      label: !hideLabel && (metricDefinition.shortLabel || metricDefinition.name),
      color: color || "currentColor",
      backgroundColor: backgroundColor
    }, (0, _common.getWidgetFontProps)(props), (0, _common.getWidgetPositionProps)(props), (0, _common.getWidgetInteractionProps)(props), {
      width: tileWidth,
      height: tileHeight
    })), showTarget && /*#__PURE__*/_react["default"].createElement(_MeasurementValue.MeasurementValue, _extends({
      dataTestId: "MetricValueElement.TargetValue",
      value: targetValue,
      units: metricDefinition.units,
      label: "Target",
      color: color || "currentColor",
      backgroundColor: backgroundColor
    }, (0, _common.getWidgetFontProps)(props), (0, _common.getWidgetPositionProps)(props), (0, _common.getWidgetInteractionProps)(props), {
      width: tileWidth,
      height: tileHeight
    })));
    if (flat && showTarget) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: "flex",
          gap: FLAT_TARGET_GAP,
          width: width,
          height: height
        }
      }, tiles);
    }
    return tiles;
  };
  var interval = timePeriod && timePeriod.interval;
  var useBatch = !isCurrent && interval && batch.isCovered(device.uuid, metricName, interval);
  var renderFromBatch = function renderFromBatch(_ref8) {
    var color = _ref8.color,
      backgroundColor = _ref8.backgroundColor;
    if (batch.isLoading(device.uuid, metricName, interval)) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    }
    return renderMeasurementValueWithOptionalTarget({
      value: batch.getValue(device.uuid, metricName, interval),
      color: color,
      backgroundColor: backgroundColor
    });
  };
  var metricRenderComponent = useBatch ? renderFromBatch : isCurrent ? renderRealtimeMetric : renderHistoricMetric;
  if (backgroundColorSource) {
    return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
      deviceUuid: device.uuid,
      value: metricValue
    }, (0, _common.getWidgetColorProps)(props)), metricRenderComponent);
  }
  return metricRenderComponent({
    color: color,
    backgroundColor: backgroundColor
  });
};